export default __webpack_public_path__ + "img/dYLQisBq.725ff067.svg";